export default `<h1><span style="font-family: CabinetGrotesk-Variable_case_club">Designed for Your Devices, Styled for Your Life
</span><br></h1>`
